export default __webpack_public_path__ + "static/media/024-mojito.38c60f53.svg";